import { render, staticRenderFns } from "./Quantity.vue?vue&type=template&id=3afccbdc&scoped=true"
import script from "./Quantity.vue?vue&type=script&lang=js"
export * from "./Quantity.vue?vue&type=script&lang=js"
import style0 from "./Quantity.vue?vue&type=style&index=0&id=3afccbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afccbdc",
  null
  
)

export default component.exports